<template>
  <v-container>
    <RecipeConfigurationNotification
      v-if="getIsAdmin === true"
    ></RecipeConfigurationNotification>
    <RecipeConfigurationAlert></RecipeConfigurationAlert>
    <v-row no-gutters align="center" justify="space-between" class="mb-1">
      <v-btn
        v-if="getIsAdmin === true"
        text
        color="success"
        @click="
          $router.push({
            name: 'RecipeEditor',
            params: { id: null, isFinalRecipe: finalRecipe }
          })
        "
      >
        <v-icon small left>fa-plus</v-icon>
        <span v-if="finalRecipe">Nouvelle recette</span>
        <span v-else>Nouvelle préparation</span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$vuetify.breakpoint.smAndUp"
        text
        :disabled="getRecipeTagsSearch.length < 1"
        @click="openListViewer"
      >
        <v-icon small>fa-external-link-alt</v-icon>
        <v-icon x-small left>fa-hashtag</v-icon>
        Exportation groupé
      </v-btn>
      <v-btn
        elevation="0"
        v-if="$vuetify.breakpoint.smAndUp && getIsAdmin"
        :to="{ name: 'RecipeBulkEditor' }"
        ><v-icon small left>fa-edit</v-icon>Éditeur avancé</v-btn
      >
    </v-row>
    <v-row align="center" no-gutters dense>
      <span class="overline">Mode d'affichage</span>
      <v-btn
        :small="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xsOnly"
        text
        @click="mode = 'normal'"
        :color="mode === 'normal' ? 'success' : ''"
      >
        <v-icon
          :size="$vuetify.breakpoint.smAndUp ? 'x-small' : 'medium'"
          :left="$vuetify.breakpoint.smAndUp"
          >mdi-nutrition</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">Normal</span>
      </v-btn>
      <v-btn
        :small="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xsOnly"
        text
        @click="mode = 'allergen'"
        :color="mode === 'allergen' ? 'success' : ''"
      >
        <v-icon
          :size="$vuetify.breakpoint.smAndUp ? 'x-small' : 'medium'"
          :left="$vuetify.breakpoint.smAndUp"
          >fa-notes-medical</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">Allergènes</span>
      </v-btn>
      <v-btn
        :small="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xsOnly"
        text
        @click="mode = 'unit'"
        :color="mode === 'unit' ? 'success' : ''"
      >
        <v-icon
          :size="$vuetify.breakpoint.smAndUp ? 'x-small' : 'medium'"
          :left="$vuetify.breakpoint.smAndUp"
          >fa-balance-scale</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">Poids & Mesures</span>
      </v-btn>
    </v-row>

    <v-card>
      <v-card-text>
        <v-row align="center" no-gutters>
          <RecipeTagsEditor
            v-model="getRecipeTagsSearchModel"
            solo-inverted
            :icon="false"
          ></RecipeTagsEditor>
        </v-row>
        <v-row no-gutters class="mt-2">
          <RecipeProductAllergenInput
            v-model="allergens"
            v-if="mode === 'allergen'"
            filled
            class="no-before"
            :icon="false"
          ></RecipeProductAllergenInput>
        </v-row>
        <RecipeGrid
          v-if="mode === 'normal'"
          :items="getFilteredRecipes"
          :loading="getRecipeLoading"
          :finalRecipe="finalRecipe"
        ></RecipeGrid>
        <v-tabs
          v-model="tabs"
          centered
          grow
          v-else-if="mode === 'allergen'"
          class="mt-1"
        >
          <v-tab>Contient</v-tab>
          <v-tab>Ne contient pas</v-tab>
          <v-tab-item :eager="true">
            <RecipeAllergenGrid
              :items="getContainsRecipes"
              :filter="allergens"
              :loading="getRecipeLoading"
              :finalRecipe="finalRecipe"
            ></RecipeAllergenGrid>
          </v-tab-item>
          <v-tab-item :eager="true">
            <RecipeAllergenGrid
              :items="getNotContainRecipes"
              :filter="allergens"
              :loading="getRecipeLoading"
              :finalRecipe="finalRecipe"
            ></RecipeAllergenGrid>
          </v-tab-item>
        </v-tabs>
        <RecipeUnitGrid
          v-if="mode === 'unit'"
          :items="getFilteredRecipes"
          :loading="getRecipeLoading"
          :finalRecipe="finalRecipe"
        ></RecipeUnitGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { userInfosMixin } from "@/mixins/userInfosMixin";
import { mapGetters } from "vuex";
import { round10 } from "round10";
import {
  RecipeGrid,
  RecipeAllergenGrid,
  RecipeTagsEditor,
  RecipeProductAllergenInput,
  RecipeConfigurationNotification
} from "../components";
import RecipeUnitGrid from "../components/RecipeUnitGrid.vue";
import RecipeConfigurationAlert from "../components/RecipeConfigurationAlert.vue";
import { api } from "@/api";
export default {
  mixins: [userInfosMixin],
  name: "RecipeIndex",
  components: {
    RecipeGrid,
    RecipeAllergenGrid,
    RecipeTagsEditor,
    RecipeProductAllergenInput,
    RecipeConfigurationNotification,
    RecipeUnitGrid,
    RecipeConfigurationAlert
  },
  props: {
    finalRecipe: {
      type: Boolean,
      default: true
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  data() {
    return {
      allergens: [],
      mode: "normal",
      tabs: 0,
      loading: false,
      recipeSelect: []
    };
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getRecipes",
      "getIngredients",
      "getIsAdmin",
      "getOrganisationId",
      "getStoreId",
      "getRecipeTagsSearch",
      "getRecipeLoading"
    ]),
    getRecipeTagsSearchModel: {
      get() {
        return this.getRecipeTagsSearch;
      },
      set(v) {
        this.$store.commit("setRecipeTagsSearch", v);
      }
    },
    getFilteredRecipes() {
      let recipes = this.getRecipes.map(x => {
        return {
          ...x,
          allergens: this.getIngredientsAllergens(x),
          percent_cost: this.getRecipeCostPercent(x)
        };
      });
      if (this.getRecipeTagsSearch.length > 0) {
        recipes = recipes.filter(
          x =>
            x.data !== null &&
            this.getRecipeTagsSearch.every(t => x.data.tags.includes(t))
        );
      }
      return recipes;
    },
    getContainsRecipes() {
      let recipes = [...this.getFilteredRecipes].filter(
        x => x.est_intermediaire === false
      );
      if (this.allergens.length > 0) {
        recipes = recipes.filter(x =>
          this.allergens.some(a =>
            x.allergens
              .map(g => g.toLowerCase())
              .join(";")
              .includes(a.toLowerCase())
          )
        );
      }
      return recipes;
    },
    getNotContainRecipes() {
      let recipes = [...this.getFilteredRecipes].filter(
        x => x.est_intermediaire === false
      );
      if (this.allergens.length > 0) {
        recipes = recipes.filter(x =>
          this.allergens.every(
            a =>
              !x.allergens
                .map(g => g.toLowerCase())
                .join(";")
                .includes(a.toLowerCase())
          )
        );
      }
      return recipes;
    }
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("loadTagCategories");
        await this.$store.dispatch("loadAllRecipeStore", {
          organisation: this.getOrganisationId,
          store: this.getStoreId
        });
      } finally {
        this.loading = false;
      }
    },
    getRecipeCostPercent(item) {
      if (item.data) {
        return item.data.prix_vente > 0
          ? round10((item.data.cost / item.data.prix_vente) * 100, -2)
          : 0;
      } else {
        return 0;
      }
    },
    async createNewRecipe(recipeName) {
      if (recipeName) {
        const data = {
          organisation: this.$store.getters.getOrganisationId,
          nom: recipeName,
          est_intermediaire: false,
          data: {
            store: this.getStoreId,
            use_conversion_formula: false
          }
        };
        try {
          this.$store.dispatch("startLoadingOverlay");
          const res = await api.postRecipe(data);
          this.$router.push({
            name: "RecipeEditor",
            params: { id: res.id }
          });
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async createNewIntermediateRecipe(recipeName) {
      if (recipeName) {
        const data = {
          organisation: this.$store.getters.getOrganisationId,
          nom: recipeName,
          est_intermediaire: true,
          data: {
            store: this.getStoreId,
            use_conversion_formula: false
          }
        };
        try {
          this.$store.dispatch("startLoadingOverlay");
          const res = await api.postRecipe(data);
          this.$router.push({
            name: "RecipeEditor",
            params: { id: res.id }
          });
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    getIngredientsAllergens(item) {
      return [
        ...new Set(
          item.ingredients
            .filter(x => x.is_deleted === false)
            .map(x => {
              const product = this.getProducts
                .filter(p => p.data !== null)
                .find(p => p.id == x.pk_recette_produit);
              if (product) {
                if (product.data && product.data.allergens.length > 0) {
                  return product.data.allergens;
                } else {
                  return [];
                }
              } else {
                return [];
              }
            })
            .flat()
        )
      ].filter(x => x !== undefined);
    },
    openListViewer() {
      if (this.getFilteredRecipes.map(x => x.id).length > 0) {
        this.$router.push({
          name: "RecipeListViewer",
          params: {
            ids: this.getFilteredRecipes.map(x => x.id)
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.recipe-card {
  margin-bottom: 1em;
}
.recipe-card:hover {
  box-shadow: inset 10px 10px 300px 200px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>
